import { render } from "./QuanTriNhanSu.vue?vue&type=template&id=8b019f14&scoped=true"
import script from "./QuanTriNhanSu.vue?vue&type=script&lang=js"
export * from "./QuanTriNhanSu.vue?vue&type=script&lang=js"

import "./QuanTriNhanSu.vue?vue&type=style&index=0&id=8b019f14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b019f14"]])

export default __exports__